module.exports = __webpack_public_path__ + "img/work-permit@2x.dfcc90f4.png";